'use strict';

const MeasurementItemController = function(
    $scope, $rootScope, Flux, AnalyticsService,
    AppDialogsActions, DashDialogsActions, PlanStore
) {

  const vm = this;
  const MeasurementStore = Flux.Store.get('MeasurementStore');
  const DataCaptureStore = Flux.Store.get('DataCaptureStore');
  const MapActions = Flux.Actions.get('MapActions');

  vm.layers = [];
  vm.selected = {};

  // Flag for when measurement is saving
  vm.saving = false;

  // Means measurement has no layers, flag for disabling save button
  vm.empty = true;

  vm.canRequestVolumeMeasurement = false;

  vm.setLayers = (measurement) => {

    // Measurements may have support for layers (multiple polygons)
    // For now, store them in the object and flatten it before saving
    measurement.layers = measurement.layers || [];
    vm.layers = measurement.layers;
    vm.empty = !(vm.layers && vm.layers.length);
  };

  // Controller may be instantiated after the active measurement has been selected,
  // so read in the initial state as well
  const initialMeasurement = MeasurementStore.get('active');
  if (initialMeasurement) {
    vm.setLayers(initialMeasurement);
    vm.canRequestVolumeMeasurement = DataCaptureStore.canRequestMeasurements();
  }

  vm.name = (...args) => {

    const activeMeasurement = MeasurementStore.get('active');
    if (activeMeasurement) {
      if (args.length === 0) { // Getter
        return activeMeasurement.name;
      }
      else { // Setter
        MeasurementStore.changeActiveName(args[0]);
        return activeMeasurement;
      }
    }

    return null;
  };

  vm.isNewRecord = () => {

    const measurement = MeasurementStore.get('active');
    return MeasurementStore.isNewRecord(measurement);
  };

  /**
   * Save the measurement
   */
  vm.save = () => {

    const measurement = MeasurementStore.get('active');
    const currentPlan = PlanStore.get('current');
    const canPlanMeasure = PlanStore.checkFeature('project', 'measurements');

    if (currentPlan && !currentPlan.isEnabled) {
      const segment = MeasurementStore.isNewRecord(measurement) ?
        'Measurement create - Disabled plan' :
        'Measurement edit - Disabled plan';
      AnalyticsService.track('[CORE] Subscription', segment, {});
      AppDialogsActions.MustBePayingCustomer.dispatch();
      return;
    }

    if (!canPlanMeasure) {
      const segment = MeasurementStore.isNewRecord(measurement) ?
        'Measurement create - Insufficient plan' :
        'Measurement edit - Insufficient plan';
      AnalyticsService.track('[CORE] Subscription', segment, {});
      DashDialogsActions.NotSupportedInPlanWarning.dispatch();
      return;
    }

    if (vm.saving) {
      return;
    }

    vm.saving = true;
    if (measurement) {

      if (MeasurementStore.isNewRecord(measurement)) {
        vm.requestMeasurement(measurement);
      }
      else {
        vm.updateMeasurement(measurement);
      }
    }
  };

  vm.closeDrawer = (options) => {

    options = options || {};
    const active = MeasurementStore.get('active');
    if (options.prompt && active && active.request) {
      $rootScope.$broadcast(options.prompt);
    }
    else {
      MapActions.MeasurementEditEnd.dispatch(false);
    }
  };

  vm.cancel = () => {

    const active = MeasurementStore.get('active');
    if (active && active.layers.length > 0) {
      $rootScope.$broadcast('dialog:measurement:promptCancelEdit');
    }
    else {
      MapActions.MeasurementEditEnd.dispatch(false);
    }
  };

  vm.getActionLabel = () => {

    return vm.isNewRecord() ? 'New Measurement' : 'Edit Measurement';
  };

  vm.requestMeasurement = (measurement) => {

    if (measurement && measurement.layers.length) {
      MapActions.NewMeasurementRequest.dispatch();
    }

    const SiteStore = Flux.Store.get('SiteStore');
    const site = SiteStore.get('current');
    AnalyticsService.track('[CORE] Measurements', 'Measurement Requested', {
      siteId: site.id,
      siteName: site.name
    });
    MeasurementStore.once(MeasurementStore.Events.ActiveSaved, () => {

      MapActions.MeasurementEditEnd.dispatch(true);
      vm.saving = false;
    });
  };

  vm.updateMeasurement = () => {

    MapActions.SaveActiveMeasurement.dispatch();
    // TODO: This should use the `waitFor` functionality of flux model.
    // Use a custom event for now instead
    MeasurementStore.once(MeasurementStore.Events.ActiveSaved, () => {

      MapActions.MeasurementEditEnd.dispatch(true);
      vm.saving = false;
    });
  };

  $scope.$on('dialog:measurement:confirmCancelEdit', () => {

    MapActions.MeasurementEditEnd.dispatch(false);
  });

  vm._handleMeasurementsChange = () => {

    const activeMeasurement = MeasurementStore.get('active');
    if (activeMeasurement) {
      vm.saving = false;
      vm.setLayers(activeMeasurement);
    }
  };

  vm._handleDataCaptureStoreChange = () => {

    MeasurementStore.emit(MeasurementStore.Events.DataCaptureChanged);
    vm.canRequestVolumeMeasurement = DataCaptureStore.canRequestMeasurements();
  };

  MeasurementStore.on(MeasurementStore.Events.Changed, this._handleMeasurementsChange.bind(this), $scope);
  MeasurementStore.on(MeasurementStore.Events.LayerRenamed, this._handleMeasurementsChange.bind(this), $scope);
  MeasurementStore.on(MeasurementStore.Events.LayerAdded, this._handleMeasurementsChange.bind(this), $scope);
  DataCaptureStore.on(DataCaptureStore.Events.Changed, this._handleDataCaptureStoreChange.bind(this), $scope);

};

MeasurementItemController.$inject = [
  '$scope', '$rootScope', 'sbFlux', 'AnalyticsService',
  'AppDialogsActions', 'DashDialogsActions', 'PlanStore'
];
module.exports = MeasurementItemController;



// WEBPACK FOOTER //
// ./src/app/dash/nav/navLeft/measurements/item/MeasurementItemController.js